/* =========================================================================
   javy-pdp-offer.js
   =========================================================================
*/

(function () {
  'use strict';

  if (window.__pdpBundleInitialized) return;
  window.__pdpBundleInitialized = true;

  var config = window.__pdpConfig;
  if (!config) return;

  var CURRENCY = config.currencySymbol || '€';

  function money(n) {
    return Math.round(n) + ' kr';
  }

  var CTA_CLASS = config.ctaClass || 'button-primary_v2';
  var flavorCards = [];
  var frequencyOptions = [];
  var meterItems = [];
  var filledLine = null;
  var mainCtaBtn = null;
  var stickyBtn = null;
  
  var subBlock = null;
  var oneTimeBlock = null;
  var futureOffEls = [];

  /* ─── Helpers ─── */
  function getTierPrice(total, tiers) {
    for (var i = tiers.length - 1; i >= 0; i--) {
      if (total >= tiers[i].min) return tiers[i].price;
    }
    return tiers[0].price;
  }

  function getFrequencyTier(total) {
    var ft = config.frequencyTiers;
    for (var i = ft.length - 1; i >= 0; i--) {
      if (total >= ft[i].min) return ft[i];
    }
    return ft[0];
  }

  function resolveSellingPlanId(days) {
    var plans = config.sellingPlans || [];
    if (!plans.length) return null;
    for (var i = 0; i < plans.length; i++) {
      var match = String(plans[i].name || '').match(/(\d+)/);
      if (match && parseInt(match[1], 10) === days) return plans[i].id;
    }
    return plans[0].id;
  }

  function getQtyDisplay(card) {
    return card.querySelector('.flavor_qty-display');
  }

  function getQty(card) {
    var el = getQtyDisplay(card);
    return el ? parseInt(el.textContent.trim(), 10) || 0 : 0;
  }

  function setQty(card, val) {
    var el = getQtyDisplay(card);
    if (el) el.textContent = val;
  }

  function getTotalBags() {
    var total = 0;
    flavorCards.forEach(function(c) {
      total += getQty(c);
    });
    return total;
  }

  function isSubscription() {
    var active = frequencyOptions.find(function(option) {
      return option.classList.contains('current-frequency');
    });

    return active ? !!active.querySelector('.frequency-sub-label-container') : false;
  }

  /* ─── Update card UI ─── */
  function updateCardUI(card) {
    var qty = getQty(card);
    var addBtn = card.querySelector('.flavor_add-btn');
    var qtyContainer = card.querySelector('.flavor2_quantity-container');
    var qtyDisplay = getQtyDisplay(card);

    if (qty > 0) {
      if (addBtn) addBtn.classList.remove('is-active');
      if (qtyContainer) {
        qtyContainer.querySelectorAll('.flavor_qty-button').forEach(function(b) {
          b.classList.add('is-active');
        });
      }
      if (qtyDisplay) qtyDisplay.classList.add('is-active');
    } else {
      if (addBtn) addBtn.classList.add('is-active');
      if (qtyContainer) {
        qtyContainer.querySelectorAll('.flavor_qty-button').forEach(function(b) {
          b.classList.remove('is-active');
        });
      }
      if (qtyDisplay) qtyDisplay.classList.remove('is-active');
    }
  }

  /* ─── Quantity meter ─── */
  function updateQuantityMeter() {
    var total = getTotalBags();

    var activeIdx = -1;
    if (total >= 4) activeIdx = 3;
    else if (total === 3) activeIdx = 2;
    else if (total === 2) activeIdx = 1;
    else if (total === 1) activeIdx = 0;

    if (filledLine) {
      filledLine.className = 'quantity-meter-line filled';
      if (activeIdx === 0) filledLine.classList.add('filled-0');
      else if (activeIdx === 1) filledLine.classList.add('filled-25');
      else if (activeIdx === 2) filledLine.classList.add('filled-50');
      else if (activeIdx >= 3) filledLine.classList.add('filled-75');
    }

    meterItems.forEach(function(item, i) {
      var circle = item.querySelector('.quantity-meter-item__circle');
      var inner = item.querySelector('.quantity-meter-item__circle-inner');
      var price = item.querySelector('.quantity-meter-item__price');

      if (i <= activeIdx) {
        if (circle) circle.classList.add('filled');
        if (inner) inner.classList.add('filled');
      } else {
        if (circle) circle.classList.remove('filled');
        if (inner) inner.classList.remove('filled');
      }

      if (price) {
        if (i === activeIdx) price.classList.remove('subdued');
        else price.classList.add('subdued');
      }
    });
  }

  /* ─── Frequency pricing ─── */
  function updateFrequencyPricing() {
    var total = getTotalBags();

    // total === 0 falls through: getTierPrice / getFrequencyTier both return
    // the base tier, so prices reset to the Liquid defaults instead of
    // freezing on the last selected quantity.
    var tierPrice = getTierPrice(total, config.tiers);
    var savingsPercent = Math.round((1 - tierPrice / config.comparePrice) * 100);
    var ft = getFrequencyTier(total);
    var oneTimePrice = getTierPrice(total, config.onetimeTiers);

    if (subBlock) {
      var subLabel = subBlock.querySelector('.frequency-sub_label');
      if (subLabel) subLabel.textContent = "SPAR " + savingsPercent + "% PÅ DIN FØRSTE ORDRE";

      var subPrice = subBlock.querySelector('.frequency-prices_inner .p-16.c-dark._w-700');
      if (subPrice) subPrice.textContent = money(tierPrice) + '/stk';

      var freqSpan = subBlock.querySelector('.frequency-sub-label');
      if (freqSpan) freqSpan.textContent = 'Hver ' + ft.days + '. dag';
    }

    futureOffEls.forEach(function(el) {
      el.textContent = ft.futureOff + '% RABAT';
    });

    if (oneTimeBlock) {
      var oneTimePriceEl = oneTimeBlock.querySelector('.frequency-prices_inner .p-16.c-dark');
      if (oneTimePriceEl) oneTimePriceEl.textContent = money(oneTimePrice) + '/stk';
    }
  }

  /* ─── CTA ─── */
  function updateCTA() {
    var total = getTotalBags();
    var btn = mainCtaBtn;
    if (!btn) return;

    var ctaTextEl = btn.querySelector('.cta-price-holder');
    if (!ctaTextEl) return;

    if (total === 0) {
      btn.disabled = true;
      btn.classList.remove(CTA_CLASS);
      btn.classList.add('button-sold-out_v2');
      btn.classList.add('button-sold-out_v2');
      ctaTextEl.innerHTML = 'Vælg mindst 1 ' + config.unit;
    } else {
      btn.disabled = false;
      btn.classList.remove('button-sold-out_v2');
      btn.classList.add(CTA_CLASS);

      var sub = isSubscription();
      var tierPrice = sub ? getTierPrice(total, config.tiers) : getTierPrice(total, config.onetimeTiers);
      var totalPrice = (tierPrice * total);
      var compareTotal = (config.comparePrice * total);

      if (compareTotal === totalPrice) {
        ctaTextEl.innerHTML = 'Læg i kurv' +
          '<div class="cta-price-holder-inner">' +
            '<span class="cta-sale-price">' + money(totalPrice) + '</span>' +
          '</div>';
      } else {
        ctaTextEl.innerHTML = 'Læg i kurv' +
          '<div class="cta-price-holder-inner">' +
            '<span class="cta-compare-price">' + money(compareTotal) + '</span>' +
            '<span class="cta-sale-price">' + money(totalPrice) + '</span>' +
          '</div>';
      }
    }

    // Sync sticky ATC
    if (stickyBtn) {
      var stickyText = stickyBtn.querySelector('.cta-price-holder');

      // Sticky should ALWAYS be clickable
      stickyBtn.disabled = false;
      stickyBtn.setAttribute('type', 'button');

      if (total === 0) {
        // Placeholder = scroll-up button. Keep it as a real primary button,
        // NOT the grayed-out sold-out style.
        stickyBtn.className = 'w-inline-block ' + CTA_CLASS + ' sticky-scroll-to-selector';
        stickyBtn.setAttribute('data-sticky-placeholder', 'true');
        if (stickyText) stickyText.innerHTML = 'Vælg din pakke';
      } else {
        // Real add-to-cart: mirror the main button.
        stickyBtn.className = btn.className;
        stickyBtn.classList.add('sticky-scroll-to-selector');
        stickyBtn.setAttribute('data-sticky-placeholder', 'false');
        if (stickyText && ctaTextEl) {
          stickyText.innerHTML = ctaTextEl.innerHTML;
        }
      }
    }
  }

  /* ─── NFP (Nutritional Information) ─── */
  function initNFP() {
  var flavors = config.flavors;
  if (!flavors || !flavors.length) return;

  var containers = Array.from(document.querySelectorAll('.nf-flavor-display'));

  if (!containers.length) return;

  var currentIndex = -1;

  function escapeHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildDropdownCards() {
    return flavors.map(function(f, i) {
      return '<div class="nf-flavor-card" data-nfp-index="' + i + '">' +
        '<img alt="" width="45" height="45" loading="lazy" decoding="async" ' +
          'data-src="' + escapeHtml(f.image) + '" ' +
          'style="background-color:' + escapeHtml(f.mainColor) + ';border-radius:4px;">' +
        '<p>' + escapeHtml(f.flavorName) + '</p>' +
      '</div>';
    }).join('');
  }

  function buildNFPDisplay(flavor) {
    return '<div class="nf-flavor-nfp reduce">' +
      (flavor.nfpImg ? '<img src="' + escapeHtml(flavor.nfpImg) + '" alt="Nutrition Facts" loading="lazy" decoding="async">' : '') +
    '</div>' +
    (flavor.nfpIngredients ? '<div class="nf-flavor-ingredients">' + flavor.nfpIngredients + '</div>' : '');
  }

  function loadDropdownImages(container) {
    container.querySelectorAll('.nf-flavor-card img[data-src]').forEach(function(img) {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    });
  }

  function initialRender() {
    containers.forEach(function(container) {
      container.innerHTML =
        '<div style="background-color:white" class="nf-flavor-select">' +
          '<span class="nf-selected-label">Vælg variant</span>' +
          '<svg class="nf-select-caret" width="12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"></rect><polyline points="208 96 128 176 48 96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"></polyline></svg>' +
        '</div>' +
        '<div class="nf-flavor-dropdown">' + buildDropdownCards() + '</div>' +
        '<div class="nf-selected-nfp"></div>';
    });
  }

  function updateSelectedFlavor(flavor) {
    containers.forEach(function(container) {
      var select = container.querySelector('.nf-flavor-select');
      var label = container.querySelector('.nf-selected-label');
      var nfpTarget = container.querySelector('.nf-selected-nfp');

      if (select) select.style.backgroundColor = flavor.mainColor || 'white';
      if (label) label.textContent = 'Variant: ' + flavor.flavorName;
      if (nfpTarget) nfpTarget.innerHTML = buildNFPDisplay(flavor);
    });
  }

  document.addEventListener('click', function(e) {
    var card = e.target.closest('.nf-flavor-card');

    if (card && card.dataset.nfpIndex !== undefined) {
      currentIndex = parseInt(card.dataset.nfpIndex, 10);
      updateSelectedFlavor(flavors[currentIndex]);

      document.querySelectorAll('.nf-flavor-dropdown').forEach(function(dd) {
        dd.classList.remove('is-active');
      });

      document.querySelectorAll('.nf-flavor-select').forEach(function(sel) {
        sel.classList.remove('is-active');
      });

      return;
    }

    var selectBtn = e.target.closest('.nf-flavor-select');

    if (selectBtn) {
      e.stopPropagation();

      var nfpContainer = selectBtn.closest('.nf-flavor-container');
      if (nfpContainer && !nfpContainer.classList.contains('is-active')) return;

      var container = selectBtn.closest('.nf-flavor-display');
      var dropdown = container ? container.querySelector('.nf-flavor-dropdown') : null;

      if (dropdown) {
        dropdown.classList.toggle('is-active');

        if (dropdown.classList.contains('is-active')) {
          loadDropdownImages(container);
        }
      }

      selectBtn.classList.toggle('is-active');
      return;
    }

    document.querySelectorAll('.nf-flavor-dropdown').forEach(function(dd) {
      dd.classList.remove('is-active');
    });

    document.querySelectorAll('.nf-flavor-select').forEach(function(sel) {
      sel.classList.remove('is-active');
    });
  });

  initialRender();
}

  /* ─── NFP toggle ─── */
  function initNFPToggle() {
    document.querySelectorAll('.nf-flavor-container').forEach(function(el) {
      el.addEventListener('click', function(e) {
        if (e.target.closest('.nf-flavor-display')) return;
        if (e.target.closest('.nf-flavor-select')) return;
        if (e.target.closest('.nf-flavor-dropdown')) return;
        this.classList.toggle('is-active');

        // Close dropdown when collapsing
        if (!this.classList.contains('is-active')) {
          this.querySelectorAll('.nf-flavor-dropdown').forEach(function(dd) {
            dd.classList.remove('is-active');
          });
          this.querySelectorAll('.nf-flavor-select').forEach(function(sel) {
            sel.classList.remove('is-active');
          });
        }
      });
    });
  }

  /* ─── Wire up flavor cards ─── */
  function initFlavorCards() {
    var container = document.querySelector('.flavors-container');
    if (!container) return;

    flavorCards.forEach(function(card) {
      updateCardUI(card);
    });

    container.addEventListener('click', function(e) {
      var card = e.target.closest('.flavor_card-item');
      if (!card) return;

      var addBtn = e.target.closest('.flavor_add-btn');
      var qtyBtn = e.target.closest('.flavor_qty-button');

      if (addBtn) {
        e.preventDefault();
        setQty(card, 1);
        updateAll(card);
        return;
      }

      if (qtyBtn) {
        e.preventDefault();

        var qtyBtns = Array.from(card.querySelectorAll('.flavor_qty-button'));
        var index = qtyBtns.indexOf(qtyBtn);
        var current = getQty(card);

        if (index === 0 && current > 0) {
          setQty(card, current - 1);
        }

        if (index === 1) {
          setQty(card, current + 1);
        }

        updateAll(card);
      }
    });
  }

  function updateMaxLimit() {
    var total = getTotalBags();
    var maxReached = total >= 10;

    flavorCards.forEach(function(card) {
      var qty = getQty(card);
      var plusBtn = card.querySelectorAll('.flavor_qty-button')[1];
      var addBtn = card.querySelector('.flavor_add-btn');

      if (maxReached && qty === 0) {
        card.classList.add('is-inactive');
        if (addBtn) addBtn.disabled = true;
      } else {
        card.classList.remove('is-inactive');
        if (addBtn) addBtn.disabled = false;
      }

      if (plusBtn) {
        plusBtn.disabled = maxReached;
        if (maxReached) {
          plusBtn.classList.remove('is-active');
          plusBtn.classList.add('is-inactive');
        } else {
          plusBtn.classList.remove('is-inactive');
        }
      }
    });
  }

  function updateAll(card) {
    updateCardUI(card);
    updateMaxLimit();
    updateQuantityMeter();
    updateCTA();
    updateFrequencyPricing();
  }

  /* ─── Frequency toggle ─── */
  function initFrequencyToggle() {
    frequencyOptions.forEach(function(option) {
      option.addEventListener('click', function() {
        frequencyOptions.forEach(function(o) {
          o.classList.remove('current-frequency');
        });

        option.classList.add('current-frequency');
        updateCTA();
        updateFrequencyPricing();
      });
    });
  }

  /* ─── Cart ─── */
  function collectItems() {
    var items = [];
    var sub = isSubscription();

    var sellingPlanId = null;

    if (sub) {
      // Frequency is based only on what the customer selected on this PDP.
      // We do NOT include existing cart quantity anymore.
      var selectedQty = getTotalBags();
      var ft = getFrequencyTier(selectedQty);

      sellingPlanId = resolveSellingPlanId(ft.days);
    }

    flavorCards.forEach(function(card) {
      var qty = getQty(card);
      if (qty < 1) return;

      var variantId = card.dataset.variantId;
      if (!variantId) return;

      var item = {
        id: parseInt(variantId, 10),
        quantity: qty
      };

      if (sub && sellingPlanId) {
        item.selling_plan = sellingPlanId;
      }

      items.push(item);
    });

    return items;
  }

  async function addItemsToCart(items) {
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });
    if (!res.ok) {
      var err = await res.json().catch(function() { return {}; });
      throw new Error(err.description || err.message || 'Add to cart failed');
    }
    return res.json();
  }

  /* ─── CTA click handler ─── */
  function initCTA() {
    var ctaHolder = document.getElementById('selector-cta');
    if (!ctaHolder) return;

    async function handleAddToCart(btn) {
      if (btn.disabled) return;

      var items = collectItems();
      if (!items.length) return;

      var ctaText = btn.querySelector('.cta-price-holder') || btn.querySelector('.checkout-btns');
      var prevHTML = ctaText ? ctaText.innerHTML : '';
      if (ctaText) ctaText.innerHTML = 'Tilføjer…';
      btn.disabled = true;

      try {
        // Show drawer with loader FIRST
        var cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) { window.location.href = '/cart'; return; }

        cartDrawer.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');

        var drawerInner = cartDrawer.querySelector('.drawer__inner');
        var loader = drawerInner.querySelector('.cart-loader');
        if (!loader) {
          loader = document.createElement('div');
          loader.className = 'cart-loader';
          loader.innerHTML = '<svg viewBox="0 0 50 50" class="cart-spinner"><circle class="ring" cx="25" cy="25" r="22.5"></circle><circle class="line" cx="25" cy="25" r="22.5"></circle></svg>';
          drawerInner.prepend(loader);
        }
        loader.classList.add('is-active');

        // THEN add items to cart
        var addResponse = await addItemsToCart(items);
        window.KinokoAtcTracker?.trackFromAddResponse(addResponse);
        try {
          var sectionsRes = await fetch('/?sections=cart-drawer');
          if (!sectionsRes.ok) throw new Error('sections fetch failed');
          var sections = await sectionsRes.json();
          // ...drawer refresh...
        } catch (e) {
          // items ARE in cart — never tell the user it failed
          window.location.href = '/cart';
          return;
        }

        // Now fetch updated drawer sections
        var sectionsRes = await fetch('/?sections=cart-drawer');
        var sections = await sectionsRes.json();

        var cartDrawerEl = document.getElementById('CartDrawer');
        if (cartDrawerEl && sections['cart-drawer']) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');
          var freshDrawer = doc.querySelector('cart-drawer');
          if (freshDrawer && freshDrawer.classList.contains('is-empty')) cartDrawer.classList.add('is-empty');
          else cartDrawer.classList.remove('is-empty');
          var freshInner = doc.querySelector('#CartDrawer');

          if (freshInner) cartDrawerEl.innerHTML = freshInner.innerHTML;

          if (false) {
            await window.javyCartDrawer.syncSubscriptionPlans(); // we purposefully disabled the sync script
          } else {
            // Fallback only: if the cart drawer sync script is not available,
            // update the visible cart badge manually.
            var addedCount = items.reduce(function(sum, item) {
              return sum + item.quantity;
            }, 0);

            document.querySelectorAll('.cart-count-bubble, .navbar-cart-qty').forEach(function(badge) {
              var visibleCountEl = badge.querySelector('[aria-hidden="true"]');
              var hiddenCountEl = badge.querySelector('.visually-hidden');

              var currentCount = 0;

              if (visibleCountEl) {
                currentCount = parseInt(visibleCountEl.textContent.trim(), 10) || 0;
              } else {
                currentCount = parseInt(badge.textContent.trim(), 10) || 0;
              }

              var newCount = currentCount + addedCount;

              if (visibleCountEl) {
                visibleCountEl.textContent = String(newCount);
              } else {
                badge.textContent = String(newCount);
              }

              if (hiddenCountEl) {
                hiddenCountEl.textContent = newCount + ' varer';
              }

              badge.classList.add('is-active');
            });
          }
        }

        loader.classList.remove('is-active');

        var overlay = document.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', function() { cartDrawer.close(); });


        
        // Reset all quantities
        flavorCards.forEach(function(card) {
          setQty(card, 0);
          updateCardUI(card);
        });
        updateQuantityMeter();
        updateMaxLimit();
        updateCTA();
        updateFrequencyPricing();

      // Reset button after successful add
        btn.disabled = false;

      } catch (err) {
        console.error('[Bundle] Add to cart failed:', err);

        // Kill the spinner
        if (loader) loader.classList.remove('is-active');

        // Close the drawer the same way we opened it
        if (cartDrawer) {
          if (typeof cartDrawer.close === 'function') {
            cartDrawer.close();
          } else {
            cartDrawer.classList.remove('animate', 'active');
          }
        }
        document.body.classList.remove('overflow-hidden');

        alert('Kunne ikke lægge i kurv. Prøv venligst igen.');
        btn.disabled = false;
        if (ctaText) ctaText.innerHTML = prevHTML;
      }
    }

    ctaHolder.addEventListener('click', function(e) {
      var btn = e.target.closest('button, .w-inline-block');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      handleAddToCart(btn);
    });

    var form = ctaHolder.querySelector('form');
    if (form) form.addEventListener('submit', function(e) { e.preventDefault(); });

    // Sticky ATC
    var stickyHolder = document.getElementById('sticky-atc');
    if (stickyHolder) {
      var stickyForm = stickyHolder.querySelector('form');
      if (stickyForm) stickyForm.addEventListener('submit', function(e) { e.preventDefault(); });

      stickyHolder.addEventListener('click', function(e) {
        var btn = e.target.closest('button, .w-inline-block');
        if (!btn) return;

        e.preventDefault();
        e.stopPropagation();

        var isPlaceholder = btn.getAttribute('data-sticky-placeholder') === 'true';

        if (isPlaceholder) {
          var selectorCta = document.getElementById('bundle-start');
          if (!selectorCta) return;

          var offset = 20;
          var targetY = selectorCta.getBoundingClientRect().top + window.pageYOffset - offset;

          window.scrollTo({
            top: targetY,
            behavior: 'smooth'
          });

          return;
        }

        handleAddToCart(btn);
      });
    }
  }

  /* ─── Image slider (Embla) ─── */
  function initPdpSlider() {
    // Only mobile
    if (window.innerWidth > 767) return;

    var section = document.querySelector('.product-images-slider');
    if (!section || typeof EmblaCarousel === 'undefined') return;

    var viewport = section.querySelector('.overflow-hidden');
    if (!viewport) return;

    var track = viewport.querySelector('.flex');
    if (!track) return;

    track.style.transform = '';
    track.style.transition = '';

    var embla = EmblaCarousel(viewport, {
      loop: false,
      align: 'start',
      slidesToScroll: 1,
      containScroll: 'trimSnaps',
      startIndex: 0
    });

    var buttons = section.querySelectorAll('button');
    var prevBtn = null;
    var nextBtn = null;

    buttons.forEach(function(btn) {
      var svg = btn.querySelector('svg path');
      if (!svg) return;

      var d = svg.getAttribute('d') || '';

      if (d.indexOf('m12 19') === 0 || d.indexOf('M19 12H5') >= 0) {
        prevBtn = btn;
      } else if (d.indexOf('M5 12h14') >= 0 || d.indexOf('m12 5') === 0) {
        nextBtn = btn;
      }
    });

    function updateButtons() {
      if (prevBtn) prevBtn.disabled = !embla.canScrollPrev();
      if (nextBtn) nextBtn.disabled = !embla.canScrollNext();
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        embla.scrollPrev();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        embla.scrollNext();
      });
    }

    updateButtons();
    embla.on('select', updateButtons);
  }

  function initScrollForMore() {
    var container = document.querySelector('.flavors-container-v2');
    var scrollHint = document.querySelector('.scroll-for-more-w');
    var gradient = document.querySelector('.scroll-for-more-gradient');

    if (!container || !scrollHint || !gradient) return;

    function checkScroll() {
      var canScroll = container.scrollHeight > container.clientHeight + 2;
      var isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 2;
      var shouldShow = canScroll && !isAtBottom;

      scrollHint.classList.toggle('is-visible', shouldShow);
      gradient.classList.toggle('is-visible', shouldShow);
    }

    container.addEventListener('scroll', checkScroll, { passive: true });
    window.addEventListener('resize', checkScroll);

    requestAnimationFrame(checkScroll);
  }

  /* ─── Boot ─── */
  function init() {
    flavorCards = Array.from(document.querySelectorAll('.flavor_card-item'));
    frequencyOptions = Array.from(document.querySelectorAll('.product-selector_variant-frequency'));
    meterItems = Array.from(document.querySelectorAll('.quantity-meter-item'));
    filledLine = document.querySelector('.quantity-meter-line.filled');
    mainCtaBtn = document.querySelector('#selector-cta button, #selector-cta .w-inline-block');
    stickyBtn = document.querySelector('#sticky-atc button, #sticky-atc .w-inline-block');

    subBlock = document.querySelector('.frequency-sub-label-container')?.closest('.product-selector_variant-frequency');

    oneTimeBlock = document.querySelector('.frequency-heading.one-time')?.closest('.product-selector_variant-frequency');

    futureOffEls = Array.from(document.querySelectorAll('.js-future-off'));

    initFlavorCards();
    initFrequencyToggle();
    initCTA();
    initNFP();
    initNFPToggle();
    initPdpSlider();
    initScrollForMore();
    updateQuantityMeter();
    updateMaxLimit();
    updateCTA();
    updateFrequencyPricing();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();